import { createSlice } from "@reduxjs/toolkit";

const getUserInfo = () => {
  try {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  } catch (e) {
    console.error("Failed to parse userInfo from localStorage:", e);
    return null;
  }
};

const initialState = {
  userInfo: getUserInfo(),
  userRole: localStorage.getItem("userRole") || null,
  token: localStorage.getItem("userToken") || null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { user, userRole, token } = action.payload;

      state.userInfo = user;
      state.userRole = userRole;
      state.token = token;

      // Store in localStorage for persistence
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("userRole", userRole);
      localStorage.setItem("userToken", token); // Store with key that apiSlice expects

      console.log("✅ Credentials set. Token:", token);
    },

    logout: (state) => {
      state.userInfo = null;
      state.userRole = null;
      state.token = null;

      // Clear localStorage
      localStorage.removeItem("user");
      localStorage.removeItem("userRole");
      localStorage.removeItem("userToken");
      localStorage.removeItem("token");
      sessionStorage.clear();

      console.log("🚪 User logged out");
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;